import { arrayToSortedString } from 'utils/areValuesEqual';

/**
 * Function which checks whether a field value was changed
 * from its default (initial) value.
 */

export default function defaultGetWasChanged(defaultValue, currentValue) {
  var isArray = Array.isArray(defaultValue) && Array.isArray(currentValue);
  if (isArray) {
    return arrayToSortedString(defaultValue) !== arrayToSortedString(currentValue);
  } else {
    return defaultValue !== currentValue;
  }
}